import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MainHeader } from '../MainHeader';
import { PhotoCollection } from '../PhotoCollection';
import { images } from './images';
import './styles.css';

export const Florals = () => {
  useEffect(() => {
    document.title = "Rue's Events Designs - Florals";
  }, []);

  return (
    <div className="collection-page">
      <MainHeader home={false} about={false} gallery={true} contact={false} />
      <section className="collection-hero">
        <p className="section-kicker">Rue's Events gallery</p>
        <h1>Florals</h1>
        <p>Floral styling and arrangements created to add beauty, texture and character to every occasion.</p>
        <div className="collection-back-link">
          <Link to="/gallery">← Back to all collections</Link>
        </div>
      </section>
      <div className="collection-gallery-shell">
        <PhotoCollection images={images} label="Florals" />
      </div>
    </div>
  );
};
